export default {
  logo: "/static/img/logo.svg",
  loadingSpinner: "/static/img/loading-spinner.svg",
  mergeIcon: "/static/img/merge-icon.svg",
  arrow: "/static/img/arrow.svg",
  googleCalendarLogo: "/static/img/google-calendar-logo.svg",
  signupHeroImage: "/static/img/signup-hero-image.png"
};
